import port1 from "../assets/portImages/port1.JPG";
import port2 from "../assets/portImages/port2.JPG";
import port3 from "../assets/portImages/port3.png";
import port4 from "../assets/portImages/port4.JPG";
import port5 from "../assets/portImages/portgeneric.jpg";
import port6 from "../assets/portImages/port6.jpg";
import port7 from "../assets/portImages/port7.png";
import port8 from "../assets/portImages/port8.png";

const portfolios = [
 {
  id: 1,
  category: "Javascript",
  link1: "https://infomania24.netlify.app/",
  icon1: "Voir le site",
  image: port1,
  title: "Info Mania 24",
  description: "Site créé pour un autoentrepreneur.",
 },
 {
  id: 2,
  category: "Javascript",
  link1: "https://wecodeproject.netlify.app/",
  icon1: "Voir le site",
  image: port2,
  title: "Wecode",
  description: "Site créé en méthodes agiles.",
 },
 {
  id: 3,
  category: "React Js",
  // link1: '#',
  icon1: "Non disponible",
  image: port3,
  title: "Wildify",
  description: "Projet non visible.",
 },
 {
  id: 4,
  category: "React Js",
  link1: "https://blablacharrette.netlify.app/",
  icon1: "Voir le site",
  image: port4,
  title: "BlaBlaCharette",
  description: "Site créé lors d'un hackathon de 36 heures.",
 },
 {
  id: 5,
  category: "React Js",
  // link1: '#',
  icon1: "Non disponible",
  image: port5,
  title: "Greeters",
  description: "Site livré mais le contenu est resté privé.",
 },
 {
  id: 6,
  category: "Unity",
  link1: "https://simmer.io/@remychazelas/zero-chicken-down",
  icon1: "Voir le site",
  image: port6,
  title: "Zero Chicken Down",
  description: "Bac à sable sur Unity, réalisé en groupe en hackathon.",
 },
 {
  id: 7,
  category: "React Native",
  link1: "https://github.com/DorotheeLagetChappert/AppToysChange",
  icon1: "Voir le site",
  image: port7,
  title: "ToysChange",
  description: "Bac à sable sur React Native.",
 },
 {
  id: 8,
  category: "React",
  link1: "https://www.devandinfo.fr/",
  icon1: "Voir le site",
  image: port8,
  title: "Dev&Info",
  description: "Site web créé dans le cadre de mon entreprenariat",
 },
];

export default portfolios;
